

export default {
    appShell: {
    "menuLabels": [
        "Market tools",
        "Futures tools",
        "Explore chains",
        "News topics"
    ],
    "closeMenu": "Close menu",
    "menuDescriptions": {
        "collect": "Track your saved coins",
        "platform": "Exchange rankings and volume",
        "toolOutsidePrice": "Compare OTC prices",
        "toolOutsideDisk": "Follow global markets",
        "toolSentimentIndex": "Fear and greed indicators",
        "manyEmpty": "Long and short positioning ratios",
        "hyperliquid": "Monitor Hyperliquid whale positions",
        "rate": "Compare exchange funding rates",
        "toolLargeIncrease": "Track large position increases",
        "toolLargeDecrease": "Track large position decreases",
        "newChain": "Explore newly listed tokens",
        "whale": "Whale and institutional holdings",
        "trace": "Follow saved addresses",
        "inscription": "Explore inscription markets",
        "toolStableCoin": "Supply, premiums and issuance",
        "toolCompanyHoldings": "Corporate BTC holdings",
        "toolMTGoxMonitor": "Monitor Mt. Gox wallet outflows",
        "toolBlockChainBrowser": "Find blockchain explorers",
        "calendar": "Key economic events and dates",
        "forum": "Community posts and discussions",
        "application": "Discover market apps and resources"
    }
,
    "back": "Back",
    "switchPage": "Pages",
    "collapse": "Close",
    "intro": "Prices, sentiment and capital flows.",
    "home": "TokenTrend home",
    "externalLink": "External site",
    "openExternal": "Open site",
    "externalBridgeHint": "You are leaving TokenTrend for an external site. After it opens, swipe from the left edge to return.",
    "light": "Use light theme",
    "dark": "Use dark theme",
    "search": "Search tokens",
    "closeSearch": "Close search",
    "brandTagline": "Prices · sentiment · flow",
    "greetingMorning": "Good morning,",
    "greetingAfternoon": "Good afternoon,",
    "greetingEvening": "Good evening,",
    "darkModeLabel": "Dark mode",
    "appearance": "Appearance",
    "themeLight": "Light",
    "themeDark": "Dark",
    "notifications": "Notifications",
    "closeNotifications": "Close notifications",
    "notifySample": [
        { "title": "Bitcoin holds above $77,000", "body": "BTC is steady after the overnight session." },
        { "title": "Funding rates stay balanced", "body": "Major exchanges remain near neutral." },
        { "title": "Market sentiment is neutral", "body": "Fear and greed is holding in the middle of the range." }
    ],
    "workspace": "Market workspace",
    "categories": "Page categories",
    "navigation": "Main navigation",
    "groups": [
        "Market",
        "Futures",
        "On-chain",
        "News",
        "Account"
    ],
    "pages": {
        "market": "Market overview",
        "platform": "Exchanges",
        "manyEmpty": "Long / short",
        "hyperliquid": "Hyperliquid whale monitor",
        "hyperliquidDetails": "Hyperliquid positions",
        "whale": "Whales & holdings",
        "burst": "Liquidations",
        "calendar": "Economic calendar",
        "burstHeatmapDetails": "Liquidation heatmap",
        "burstCoinStatisticsDetails": "Coin liquidations",
        "rate": "Funding rates",
        "application": "Applications",
        "publicChain": "Blockchains",
        "newChain": "New tokens",
        "inscription": "Inscriptions",
        "consult": "News",
        "solswap": "Token swap",
        "my": "Account",
        "signIn": "Daily check-in",
        "contractCheck": "Contract check",
        "userHitNewRobotInfo": "Token trading",
        "calendarDetail": "Event details",
        "consultDetails": "Article details",
        "newCoinDetails": "Token details",
        "firmOffer": "Live trading"
    }
},
    common: {
        empty: 'No data',
        listLoading: 'Loading...',
        listNoMore: 'No more',
        tenThousand: "×10K",
        hundredMillion: "×100M",
        copy: "Copy",
        copySuccess: "Copied",
        sendSuccess: "Sent successfully",
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        contact: 'Contact us',
        privacy: "Privacy policy"
    },
    contact: {
        title: 'Contact Us',
        info1: 'TokenTrend',
        info2: 'Email:',
    },
    homeNav: {
        market: 'Market',
        platform: 'Platform',
        manyEmpty: "Long/short",
        whale: 'Whale',
        burst: "Liquidations",
        rate: "Funding rates",
        calendar: 'Calendar',
        inscription: "Inscriptions",
        application: 'App',
        searchPlaceholder: "Search by address or coin",
        searchTitle1: "Contracts",
        searchTitle2: "Coins",
        searchList1: 'On-chain transaction volume',
        searchList2: "Circulating supply",
        searchNoResult: 'No search results yet',
        historyTitle: "Recent searches"
    },
    calendar: {
        title: 'Calendar',
        tit1: 'Important Only',
        tit2: 'Economic Data',
        tit3: 'Events',
        week0: 'Sunday',
        week1: 'Monday',
        week2: 'Tuesday',
        week3: 'Wednesday',
        week4: 'Thursday',
        week5: 'Friday',
        week6: 'Saturday',
        tab1: 'Data/Time',
        tab2: 'Previous/Forecast',
        tab3: 'Importance/Release',
        event1: 'Country/Time',
        event2: 'Event/Importance',
    }, calendar_details: {
        label1: 'Latest Release',
        label2: 'Actual',
        label3: 'Forecast',
        label4: 'Previous',
        label5: 'Next Release Time',
        label6: 'Release Frequency',
        label7: 'Importance',
        label8: 'Data Explanation',
        label9: 'Market Impact',
        label10: 'Statistical Method',
        label11: 'Publishing Agency',
        label12: 'Historical Data',
        label13: '1 Year',
        label14: '2 Years',
        label15: '5 Years',

"title": "Economic event details"
},
    footerNav: {
        publicChain: 'Chains',
        newChain: "New tokens",
        inscription: "Inscriptions",
        smartMoney: "Smart money",
        consult: 'News',
        calendar: 'Calendar',
        my: "Account",
    },
    login: {
        title: "Log in",
        enterUserName: 'Please enter email/username',
        enterPassword: 'Please enter password',
        enterLogin: "Log in",
        loginTip: "Logging in…",
        forgotPassword: "Forgot password?",
        register: "Create account",
    },
    register: {
        title: "Create account",
        enterUserName: 'username',
        enterPassword: 'password',
        enterEmail: 'e-mail',
        enterCode: 'E-mail verification code',
        inviteCode: 'Invitation code (optional)',
        sendEmailCode: 'Send the verification code',
        enterUserNameErr: 'Please enter user name',
        enterUserNameErr2: 'The user name consists of 6 to 16 letters or numbers',
        enterPasswordErr: 'Please enter password',
        enterPasswordErr2: 'Password consists of 8~18 English letters, numbers, and special symbols',
        enterEmailErr: 'Please enter email',
        enterEmailErr2: 'Please enter a correct email address',
        enterCodeErr: 'Please enter the email verification code',
        enterRegister: "Create account",
        registerSuccess: 'Registration successful, you will be redirected to the login page...',
        toLogin: "Already have an account? Log in",
        emailCodeTip: 'If you haven\'t received the email in your inbox, it may have been mistakenly classified as spam. Please check your email spam folder.'
    },
    userDelete: {
        title: "Delete Account",
        enterUserName: "Username",
        enterPassword: "Password",
        enterEmail: "Email",
        enterCode: "Email Verification Code",
        sendEmailCode: "Send Verification Code",
        enterUserNameErr: "Please enter your username",
        enterPasswordErr: "Please enter your password",
        enterEmailErr: "Please enter your email",
        enterCodeErr: "Please enter the email verification code",
        enterRegister: "Confirm Deletion",
        registerSuccess: "Deletion successful, redirecting to login page...",
    },
    forgotPassword: {
        title: "Reset password",
        enterEmail: 'e-mail',
        enterCode: 'E-mail verification code',
        sendEmailCode: 'Send the verification code',
        enterEmailErr: 'Please enter email',
        enterEmailErr2: 'Please enter a correct email address',
        enterCodeErr: 'Please enter the email verification code',
        enterPassword: 'New Password',
        enterPasswordErr: 'Please enter a new password',
        enterPasswordErr2: 'Password consists of 8~18 English letters, numbers, and special symbols',
        enterBtn1: 'Cancel',
        enterBtn2: "Confirm",
        forgotPasswordSuccess: 'Modification successful, you will be redirected to the login page...'
    },
    coinDetails: {
        title: "Coin Details",
        topInfo1: "24H Change",
        tab1: "Trading data",
        tab2: "Coin information",
        topInfo2: "24H High Price",
        topInfo3: "24H Low Price",
        topInfo4: "Trading Volume",
        topInfo5: "24H Turnover",
        topInfo6: "24H Opening Price",
        topInfo7: "All-Time Low Price",
        bottomInfo1: "Coin",
        bottomInfo2: "Full Name",
        bottomInfo3: "Official Website",
        bottomInfo4: "All-Time High Price",
        bottomInfo5: "All-Time Low Price",
        bottomInfo6: "Circulating Supply",
        bottomInfo7: "Total Issuance",
        bottomInfo8: "Max Supply",
        bottomInfo9: "Listing Date",
        bottomInfo10: "Telegram",
        bottomInfo11: "Whitepaper Link",
        bottomInfo12: "Hotness Rank",
        bottomInfo13: "Market Cap Rank"
    ,
"trade_txt1": "Capital flows",
"trade_txt2": "Position analysis",
"trade_txt3": "Long/short ratio",
"trade_txt4": "Large-holder positions",
"trade_txt5": "Large-holder liquidity",
"trade_txt6": "Large-holder trades",
"trade_txt7": "Large-holder position distribution"
},
    insdetail: {
        title: 'Inscription Details',
        topInfo1: 'Market Cap',
        topInfo2: 'Trading Volume',
        topInfo3: '24H Trading Volume',
        topInfo4: 'Holders',
        topInfo5: 'Transactions',
        topInfo6: 'Pending',
        topInfo7: 'Progress',
        bottomInfo1: 'Name',
        bottomInfo2: 'Supply',
        bottomInfo3: 'Inscription ID',
        bottomInfo4: 'ID',
        bottomInfo5: 'Single Minting',
        bottomInfo6: 'Creator',
        bottomInfo7: 'Final Inscription',
        bottomInfo8: 'Precision',
        bottomInfo9: 'Create Time',
        tab1: 'Trade History',
        tab2: 'Overview',
        cycle1: '24H',
        cycle2: '7Day',
        cycle3: '30Day',
    },
    swap: {
        title: 'Swap',
        pay: 'You pay',
        receive: 'Estimated receive',
        reverse: 'Reverse swap direction',
        title1: 'Swap',
        title2: 'Connect wallet',
        title3: 'Disconnect wallet',
        title4: 'Back',
        title5: 'Slippage',
        title6: 'Est network fee',
        title7: 'Swap',
        title8: 'Balance not enough',
        title9: 'Rate',
        msg1: 'Wallet Connected',
        msg2: 'Wallet Disconnected',
        msg3: 'Please enter a valid amount',
        msg4: 'Please connect wallet first',
        msg5: 'Please open okx wallet to sign the transaction',
        msg6: 'Swap completed successfully!',
    },
    newCoinDetails: {
        topInfo1: 'Circulation',
        topInfo2: 'Circulation rate',
        topInfo3: 'Sale',
        topInfo4: 'Issuance',
        topInfo5: 'Chg.24H',
        topInfo6: 'Latest Price',
        topInfo7: 'Issue Price',
        topInfo8: 'Pre-Sale',
        topInfo9: 'Platform',
        topInfo10: 'Sales ratio',
        topInfo11: 'Direct link',
        listTitle: 'Market',
        list1: 'Platform',
        list2: 'Coin pair',
        list3: '24H VOL',
        list4: '24H Volume ($)',
        list5: 'Ratio',

"title": "New token details"
},
    coinTrade: {
        title1: 'Capital Flow Analysis',
        title2: '24H Net Capital Inflow',
        title3: '5-Day Main Net Inflow',
        title4: 'Leverage Loan Stock Growth Rate',
        title5: 'Leverage Long-Short Ratio',
        title6: 'Isolated Margin Loan Ratio',
        tableTh11: 'Order',
        tableTh12: 'Buy',
        tableTh13: 'Sell',
        tableTh14: 'Net Inflow',
        tableTh15: 'Large Order',
        tableTh16: 'Medium Order',
        tableTh17: 'Small Order',
        tableTh18: 'Total',
        chart11: 'Large Buy Orders',
        chart12: 'Medium Buy Orders',
        chart13: 'Small Buy Orders',
        chart14: 'Large Sell Orders',
        chart15: 'Medium Sell Orders',
        chart16: 'Small Sell Orders',
    },
    platformDetails: {
        title: 'Platform details',
        volumn24h: '24H transaction volume',
        title1: 'Introduction',
        content1: 'Established:',
        content2: 'Registration:',
        content3: 'KYC verification',
        content4: 'Quantization interface',
        content5: 'assets',
        content6: 'Quantity of trading pairs',
        content7: 'official website',
        isTrue: 'yes',
        isFalse: 'no',
        title2: 'Transaction support',
        content8: 'Spots',
        content9: 'Contract',
        content10: 'OTC',
        content11: 'Legal tender',
        title3: 'Related links',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    topHome: {
        marketSentiment: 'Market sentiment',
        sentimentDetails: 'View details',
        sentimentUnavailable: 'Unavailable',
        sentimentIndexBlock1: 'Sentiment Index',
        sentimentIndexBlock1_1: 'Extreme panic',
        sentimentIndexBlock1_2: 'Panic',
        sentimentIndexBlock1_3: 'Neutral',
        sentimentIndexBlock1_4: 'Greedy',
        sentimentIndexBlock1_5: 'Extreme greed',
        sentimentIndexBlock2: 'BTC Positions Long/Short',
        sentimentIndexBlock2_1: 'Bull advantage',
        sentimentIndexBlock2_2: 'Short advantage',
    },
    market: {
        tabs1: 'Hot',
        tabs2: 'Top Gainers',
        tabs3: 'Top Losers',
        tabs4: 'New Coins',
        tabs5: 'Soaring',
        tabs6: 'Market Cap',
        tabs7: 'Trading Volume',
        popularTh1: "Coin/24H Volume",
        popularTh2: "Price/24H Turnover",
        popularTh3: "Chg.24H",
        newCoinTh1: "Coin/Listing Time",
        newCoinTh2: "Price/24H Turnover",
        newCoinTh3: "Chg.24H/Volume",
        marketTh1: "Coin/Market Cap",
        marketTh2: "Price/24H Turnover",
        marketTh3: "Chg.24H/Volume"
    },
    platform: {
        tabs1: 'Global Exchange Asset Ranking',
        exchangeTableTh1: 'Exchanges',
        exchangeTableTh2: 'Assets',
        exchangeTableTh3: 'Website',
    },
    manyEmpty: {
        overviewHint: "Track long and short positioning across volume, accounts and holdings.",
        topTraders: "Top traders",
        latestRatio: "Latest long/short ratio",
        balanced: "Balanced",
        longBias: "More longs",
        shortBias: "More shorts",
        interval: "Time interval",
        chartView: "Chart view",
        shareView: "Share",
        loading: "Loading…",
        failed: "Unable to load",
        noData: "No data for this selection",
        retry: "Retry",
        touchHint: "Touch chart to inspect",

        title1: 'Volume Ratio',
        title2: 'People Ratio',
        title3: 'TOP Account Ratio',
        title4: 'TOP Holdings Ratio',
        progress1: 'Long: ',
        progress2: 'Short: ',
        tableTh1: 'Exchange',
        tableTh2: 'Ratio',
        tableTh3: 'Long %',
        tableTh4: 'Short %',
        msg1: 'Ratio',
        msg2: 'Long',
        msg3: 'Short',
        msg4: 'People Ratio',
        msg5: 'Long People',
        msg6: 'Short People',
        msg7: 'Account Ratio',
        msg8: 'Long Accounts',
        msg9: 'Short Accounts',
        msg10: 'Holdings Ratio',
        msg11: 'Long Holdings',
        msg12: 'Short Holdings',
    },
    whale: {
        holdingsTitle: 'Grayscale position',
        holdingsTitle2: 'Update time:',
        holdingsTh1: 'Changes',
        holdingsTh1_1: '1D:',
        holdingsTh1_2: '7D:',
        holdingsTh1_3: '30D:',
        holdingsTh2: 'Premium rate',
        holdingsTh3: 'Number of coin',
        holdingsTh4: 'Position cost',
        contractTitle: 'Total contract positions',
        contractTh1: 'Exchange',
        contractTh2: 'Cost($)',
        contractTh3: 'Positions',
        contractTh4: '15M change',
        contractTh5: '1D change',
        exchangeTitle: 'Exchange balance list',
        exchangeTh1: 'Exchange',
        exchangeTh2: 'Wallets',
        exchangeTh3: '24H change',
        exchangeTh4: '7D Change',
        exchangeTh5: '30D Change',
        statistics1: 'Total market',
        statistics2: '24H Volume',
        statistics3: '24H high',
        listRight1: 'In:',
        listRight2: 'Out:',
        listRight3: 'Amount:',
    },
    autosearch: {
        msg: 'Search',
        msg1: 'Please enter a keyword(exchange,coin name)',
        msg2: 'Clear',
        msg3: 'No more data',
        msg4: 'No relevant data found',
    },
    burst: {
    explorerView: "Liquidation charts",
    explorerheatmap: "Heatmap",
    explorermap: "Liquidation map",
    explorerOtherLeverage: "Other leverage",
    explorerCumulativeLong: "Cumulative long liquidations",
    explorerCumulativeShort: "Cumulative short liquidations",
    explorerClose: "Close",
    explorerExpand: "Expand chart",
    explorerCoin: "Coin",
    explorerScope: "Exchange",
    explorerPair: "Exchange",
    explorerAll: "All markets",
    explorerEstimate: "Estimated liquidation zones",
    explorerPrice: "Latest reference price",
    explorerAbove: "Main zone above",
    explorerBelow: "Main zone below",

        currentPrice: 'Current price：',
        liquidationTip1: 'Multiple clearing',
        liquidationTip2: 'Empty clearing',
        liquidationTip3: '10x lever',
        liquidationTip4: '25x lever',
        liquidationTip5: '50x lever',
        liquidationTip6: '100x lever',
        heatmapTop: 'Comprehensive data from the three major exchanges of Binance, Huobi and OKX, the maximum liquidation point of {0}USDT is near {1}, and the liquidation value is {2}USDT. Please pay attention to the capital risk',
        toBurstHeat: 'Details',
        heatmapMaximum: 'Max intensity',
        heatmapMinimum: 'Min',
        heatmapKLine1: 'K-line',
        heatmapKLine2: 'Intensity',
        heatmapTip1: 'Price',
        heatmapTip2: 'Intensity',
        kLineTip1: 'Open',
        kLineTip2: 'Close',
        kLineTip3: 'High',
        kLineTip4: 'Lowe',
        noLogin: 'View the heat map after logging in,',
        toLogin: 'Go to login',
        topBlockH4: '1H Liqs',
        topBlockH41: '4H Liqs',
        topBlockH42: '12H Liqs',
        topBlockH43: '24H Liqs',
        topBlockP: 'Long',
        rankingTitle: 'Last 24H, Liqs ranking:',
        rankingTh1: 'Exchange',
        rankingTh2: 'Amount',
        rankingTh3: 'Liqs USD',
        rankingTh4: 'Long USD',
        rankingTh5: 'Short USD',
        coinStatisticsH4: 'Liqs statistics of each coin',
        coinStatisticsT1: '1H',
        coinStatisticsT2: '4H',
        coinStatisticsT3: '24H',
        exchangeProportionH4: 'Proportion of Liqs positions in all exchanges',
        exchangeProportionT1: '4H',
        exchangeProportionT2: '12H',
        exchangeProportionT3: '24H',
        heatmapDetailsList1Top: 'Short',
        heatmapDetailsList1Bottom: 'Long',
        heatmapDetailsList1: 'Dir:',
        heatmapDetailsList2: 'Price:',
        heatmapDetailsList3: 'Liquidation:',
        coinStatisticsDetailsTh1: 'Coin',
        coinStatisticsDetailsTh2: 'Long',
        coinStatisticsDetailsTh3: 'Short',
        coinStatisticsDetailsTh4: 'Time',
    },
    rate: {
        title1: 'Rate',
        type1: "Pos Weighted",
        type2: "Txn Weighted",
        price: 'Price',
        newTitle: 'Exchange current funding rate list',
        newTableTh1: 'Coin',
        newTableTd1: 'Predicted',
        tableTh1Old: 'Exchange',
        tableTh2Old: 'Current rate',
        tableTh3Old: 'High rate',
        tableTh4Old: 'Lowe rate',
    },
    application: {
        leftNav1: 'App',
        leftNav2: 'Wallet',
        leftNav3: 'SNS',
        visit: 'Visit',
        empty: 'Nothing here yet',
        download: 'Download',
        register: 'Register'
    },
    publicChain: {
        loadFailed: 'Unable to load tokens. Please retry.',
        retry: 'Retry',

        tableTh1: 'Pair/MarketCap',
        tableTh2: 'Price/Volume',
        tableTh3: 'Change/Time',
    },
    inscription: {
        typeAll: 'all',
        tableTh1: 'Sort',
        tableTh2: 'Coin',
        tableTh3: 'Holder',
        tableTh4: 'Transaction',
        tableTh5: 'Price',
    },
    smartMoney: {
        swipe1: 'Let the smart money work for us',
        swipe2_1: 'Specially customized for newbies in the currency circle',
        swipe2_2: 'Helping retail investors seize opportunities',
        listTip: '7x24H monitoring',
        list1Title: 'Top 100 High Frequency Trading',
        list1Msg: 'Top 100 comprehensive income/yield rate of 8 major public chains',
        list2Title: 'Celebrity Smart Money',
        list2Msg: 'Global celebrities/public chain founders/well-known institutions address tracking',
        list3Title: 'Level 1 smart money',
        list3Msg: 'Smart money with higher/stable primary market returns',
        list4Title: 'custom smart money',
        list4Msg: 'Tracking wallet address added by user',
    },
    smartMoneyTop100: {
        topTip: 'Comprehensive analysis data of major DEX in the past 30 days. The balance is for reference only! ',
        amountUsd: 'Token Total Win Rate',
        floatProfit: 'Trading Volume',
        floatProfitPercent: 'Number of Trades',
        profit: 'Profit',
        profitPercent: 'Profit rate',
        collectTo: 'Collect',
        collectCancel: 'Cancel',
        noLogin: 'After logging in, you can view and track the top 100 smart money with the highest returns in the world,',
        toLogin: 'Go to login',
    },
    smartMoneyStar: {
        title: 'Celebrity smart money',
    },
    smartMoneyOneLevel: {
        title: 'Level 1 smart money',
    },
    smartMoneyCustom: {
        title: 'Custom smart money',
        addName: 'Name:',
        addNameRules: 'Please enter a name',
        addAddress: 'Address:',
        addAddressRules: 'Please enter address',
        addComment: 'Remark:',
        addConfirm: 'Confirm',
        addSuccess: 'Added successfully! ',
        delBtn: 'Del',
        delSuccess: 'Successfully deleted! '
    },
    smartMoneyDetails: {
        queryTokenAll: 'All',
        return: 'Return',
        dexAddress: 'Address:',
        dexHash: 'Hash:',
        dexChainName: 'Chain:',
        dexTransactionAmount: 'Amount:',
        dexTrackerIn: 'To contract:',
        dexTrackerOut: 'Out contract:',
        dexTrackerType: 'Dir.:',
        dexTrackerTypeCon: '{0}{1} is converted to {2}{3}',
        dexTransactionTime: 'Time:',
        ordinaryHash: 'Hash:',
        ordinaryFrom: 'Sender:',
        ordinaryTo: 'Receiver:',
        ordinarySymbol: 'Coin:',
        ordinaryAmount: 'Amount:',
        ordinaryTime: 'Time:',
    },
    consult: {
        topNav1: 'News Briefs',
        topNav2: 'Announcement',
        topNav3: 'News',
        detailsShare: 'Share:',
        detailsTime: 'Time'
    },
    my: {
        headPictureSuccess: 'Successfully modified! ',
        toSignIn: 'Sign in',
        wallet: 'Sign in wallet balance',
        details: 'Details',
        memberTitle: 'Member Centre',
        memberItem1: 'Contract check',
        memberItem2: 'Withdraw coins',
        memberItem3: 'Customer service',
        memberItem4: 'Invitation link',
        installMetaMask: 'Please install Metamask first! ',
        nav1: "Watchlist",
        nav2: "Tracking",
        nav3: 'Team',
        nav4: 'Forum',
        nav5: "Tools",
        nav6: 'Language',
        nav7: "Log out",
        nav8: 'Binding API',
        nav9: 'Create a new robot',
        nav10: "Delete Account",
        nav11: "Log out"
    },
    signIn: {
        title: 'Checked in for {0} days',
        btn: 'Sign in now',
        tip1: "Browse the platform for {0} minutes and you can receive the sign-in reward",
        tip2: '(You have viewed {0} minutes {1} seconds)',
        success: 'Sign in successfully! ',
        recordTitle: 'Sign-in record',
        recordListContent: 'Time:',
    },
    signInRecord: {
        title: 'Wallet Details',
        selectAll: 'All',
        typeSelect1: 'Sign-in Rewards',
        typeSelect2: 'Direct Push Rewards',
        typeSelect3: 'Team Rewards',
        typeSelect4: 'Withdrawal Deductions',
        typeSelect5: 'System Rejection',
    },
    contractCheck: {
        riskAssessment: 'risk assessment',
        riskInspection: 'Risk Check',
        enterPlaceholder: 'Please enter the contract address',
        enterBtn: 'examine',
        checkNFT1: ['Non-malicious NFT', 'Malicious NFT'],
        checkNFT2: ['Not open source', 'Open source'],
        checkNFT3: ['Contract without agency', 'Contract with agency'],
        checkNFT4: ['Unverified', 'Verified'],
        checkNFT5: ['Not a famous and trustworthy NFT', 'A famous and trustworthy NFT'],
        checkToken1: ['Does not have the function to modify the maximum transaction amount or the maximum token position', 'Has the function to modify the maximum transaction amount or the maximum token position'],
        checkToken2: ['Ownership cannot be recovered', 'Ownership can be recovered'],
        checkToken3: ['The contract has no hidden owner', 'The contract has a hidden owner'],
        checkToken4: ['Does not have the function of limiting the maximum transaction volume or maximum position of a single address', 'Has the function of limiting the maximum transaction volume or the maximum position of a single address'],
        checkToken5: ['Token is not a honeypot', 'Token is a honeypot'],
        checkToken6: ['Tokens cannot be traded on decentralized exchanges', 'Tokens can be traded on decentralized exchanges'],
        checkToken7: ['The contract does not have the ability to mint tokens', 'The contract has the ability to mint tokens'],
        checkToken8: ['Not open source', 'Open source'],
        checkToken9: ['not an agent', 'is an agent'],
        checkToken10: ['The contract owner cannot change the token holder balance', 'The contract owner can change the token holder balance'],
        checkToken11: ['You cannot set a different tax rate for each assigned address', 'You can set a different tax rate for each assigned address'],
        checkToken12: ['The contract cannot self-destruct', 'The contract can self-destruct'],
        checkToken13: ['The contract does not have a transaction cooling mechanism', 'The contract has a transaction cooling mechanism'],
        checkToken14: ['Trading cannot be suspended through the token contract', 'Trading can be suspended through the token contract'],
        checkToken15: ['This token is not a famous and trustworthy token', 'This token is a famous and trustworthy token'],
        botToken1: 'Owner address',
        botToken2: 'Owner\'s Balance',
        botToken3: 'Percentage of tokens held by owners',
        botToken4: 'Supply quantity',
        botNFT1: 'Total transaction volume',
        botNFT2: 'Number of holders',
        botNFT3: 'highest price',
        botNFT4: '24-hour average price',
        botNFT5: '24 hours lowest price',
    },
    withdrawal: {
        title: 'Withdraw coins',
        titleTip: 'The withdrawal address must be the wallet address of the TRON (TRC-20) chain. Filling in the wallet address of other chains will result in permanent loss and cannot be recovered. ',
        withdrawalAddress: 'Your withdrawal address:',
        inputWithdrawalAddress: 'Please enter the withdrawal address',
        number: 'quantity',
        inputNumber: 'Please enter the quantity',
        inputNumberErr: 'Insufficient balance',
        balance: 'Balance',
        actualReceipt: 'Actual arrival:',
        gas: 'Handling fee:',
        tip: 'The minimum withdrawal is {0}USDT, and the withdrawal fee is {1}%. ',
        confirm: 'Confirm',
        explain: 'Online transactions take 0-2 hours, and online confirmation is not included',
        submitSuccess: 'Submitted successfully'
    },
    withdrawalRecord: {
        title: 'Withdrawal Record',
        list1: 'Address:',
        list2: 'Network:',
        list3: 'Coin:',
        list4: 'Num:',
        list5: 'Fee:',
        list6: 'Status:',
        list7: 'Time:',
        status0: 'pending',
        status1: 'approved',
        status2: 'rejected',
    },
    bindingApi: {
        title: 'Binding API',
        tip: 'Exchange creation API requires IP binding',
        listTitle: 'Binding List',
        unBindBtn: 'Unbind',
        availableBalance: 'Available Balance:',
        bindFrom1: 'Select Exchange:',
        bindFrom1Err: 'Please select an exchange',
        bindFrom2Err: 'Please enter API key',
        bindFrom3Err: 'Please enter Secret key',
        bindFrom4Err: 'Please enter PassPhrase(OKX required)',
        bindFrom5: 'Remarks:',
        bindFrom5Err: 'Please enter a comment',
        bindSuccess: 'Binding successful',
        unBindSuccess: 'Unbind successfully'
    },
    myAsset: {
        disconnect: 'Disconnect'
    },
    collect: {
        title: 'Collect',
        amountUsd: 'Balance',
        floatProfit: 'Floating',
        floatProfitPercent: 'Floating rate',
        profit: 'Profit',
        profitPercent: 'Profit rate',
        cancel: 'Cancel',
        cancelSuccess: 'Cancel success! ',
    },
    trace: {
        title: 'Track',
        list1: 'Chain name:',
        list2: 'Token name:',
        list3: 'Address:',
        listDel: 'Del',
        listDelSuccess: 'Successfully deleted! ',
    },
    team: {
        title: 'Team',
        topInfo1: 'Direct referrals',
        topInfo2: 'Team size',
        topInfoUnit: 'people',
        tableTh1: 'Username',
        tableTh2: 'Registered',
        inviteCode: 'Invite code',
        empty: 'No direct referrals yet. Share your invite link to grow the team.',
    },
    forum: {
        title: 'Forum',
        toForumPublishNoLogin: 'Please log in first, and you can publish after logging in! ',
        publishTitle: 'Publish Forum',
        publishContentPlaceholder: 'Please enter content',
        publishSuccess: 'Published successfully! ',
        publishConfirm: 'Release',
        forumList1: 'More',
        detailsTitle: 'Forum details',
        detailsCommentTitle: 'Comment',
        detailsCommentInputPlaceholder: 'Please enter the comment content',
        detailsCommentInputSuccess: 'Sent successfully! ',
        detailsCommentInputBtn: 'Send',
    },
    tool: {
        title: 'Tool',
        tool1: 'BTC Company Position',
        tool2: 'Sentiment Index',
        tool3: 'Mentougou Monitoring',
        tool4: 'OTC price',
        tool5: 'External disk information',
        tool6: 'Large traders increase their positions',
        tool7: 'Large traders reduce their positions',
        tool8: 'Stablecoin',
        tool9: 'Blockchain Browser',
    },
    toolCompanyHoldings: {
        title: 'BTC holding institution',
        titleSub1: 'Global company BTC holding data',
        globalDataT1: 'BTC holding company',
        globalDataD1: 'Home',
        globalDataT2: 'Companys total positions',
        globalDataD2: '7D Changes:',
        globalDataT3: 'Total value of positions',
        globalDataD3: '7D Changes:',
        globalDataT4: 'Positions for BTC market',
        globalDataD4: 'Percentage 7D ago:',
        titleSub2: 'BTC holding company',
        listTh1_1: 'Position($)/',
        listTh1_2: 'Account of BTC market',
        listTh2_1: 'Position BTC/',
        listTh2_2: '7D changes',
        listTh3_1: 'Total cost/',
        listTh3_2: 'Average($)',
    },
    toolSentimentIndex: {
        title: 'Sentiment Index',
        titleSub1: 'Panic and Greed Index',
        titleSub1_1: 'Panic and greed index of BTC and important mainstream currencies',
        gauge1: 'Extreme panic',
        gauge2: 'panic',
        gauge3: 'Neutral',
        gauge4: 'greedy',
        gauge5: 'Extreme greed',
        titleSub2: 'Historical index',
    },
    toolMTGoxMonitor: {
        title: 'Mentougou Monitoring',
        titleSub1: 'Mentougou (MTGox) BTC wallet',
        topLabel1: 'Originally BTC',
        topLabel1Span: 'Original',
        topLabel2: 'Remaining BTC',
        topLabel2Span: 'Current',
        topLabel3: 'BTC change',
        titleSub2: 'BTC cold wallet chain records',
        tableTh1: 'transaction hour',
        tableTh2: 'Cold wallet address',
        tableTh3: 'Transfer amount',
    },
    toolOutsidePrice: {
        title: 'OTC price',
        th1: 'Exchange',
        th2: 'Average price',
        th3: 'Premium',
    },
    toolOutsideDisk: {
        title: 'External disk information',
        itemTitleSpan: 'Renew',
        itemTitle2: 'Open time:',
        beijingTime: 'Beijing time',
        nextDay: 'next day',
        itemInfo1: 'Prev. Close',
        itemInfo2: 'OC',
        itemInfo3: 'VOL',
        itemInfo4: 'Today\'s High',
        itemInfo5: 'Today\'s Low',
        itemInfo6: 'YTD High',
        itemInfo7: 'YTD Low',
        names: {
            BRENT: 'Brent Crude',
            DJI: 'Dow Jones',
            HKHSI: 'Hang Seng',
            INX: 'S&P 500',
            IXIC: 'Nasdaq Composite',
            N225: 'Nikkei 225',
            SH000001: 'SSE Composite',
            SH000300: 'CSI 300',
            WTI: 'WTI Crude',
            XAU: 'London Gold (Spot)',
        },
    },
    toolLargeIncrease: {
        title: 'Large traders increase their positions',
        tableTh1: 'Coin',
        tableTh2: 'Chg.24H',
        tableTh3: '24H ratio',
        tableTh4: 'Weekly ratio',
        tableTh5: 'Monthly ratio',
        tableTh6: 'Global Index($)',
        tableTh7: 'Top 10 ratio',
        tableTh8: 'Top 20 ratio',
        tableTh9: 'Top 50 ratio',
        tableTh10: 'Top 100 ratio',
    },
    toolLargeDecrease: {
        title: 'Large traders reduce their positions',
        tableTh1: 'Coin',
        tableTh2: 'Chg.24H',
        tableTh3: '24H ratio',
        tableTh4: 'Weekly ratio',
        tableTh5: 'Monthly ratio',
        tableTh6: 'Global Index($)',
        tableTh7: 'Top 10 ratio',
        tableTh8: 'Top 20 ratio',
        tableTh9: 'Top 50 ratio',
        tableTh10: 'Top 100 ratio',
    },
    toolStableCoin: {
        title: 'Stablecoin',
        UsdTopInfo1: 'USDT OTC price',
        UsdTopInfo2: 'USD Rate',
        UsdTopInfo3: 'USDT Premium',
        UsdTitleSub1: 'USDT Related index trend',
        UsdIndexQuery1: '7D',
        UsdIndexQuery2: '30D',
        UsdTitleSub2: 'USDT Premium related trends',
        relatedTitleSub1: 'Stablecoin Overview',
        relatedTopTh1: 'Coin',
        relatedTopTh2: 'OTC price (¥)/Premium',
        relatedTopTh3: 'Circulation',
        relatedTitleSub2: 'Stablecoin circulation',
        relatedQuery1: '30D',
        relatedQuery2: 'YTD',
        relatedTitleSub3: 'Proportion of stablecoin circulation',
        relatedTitleSub4: 'Issue on the stablecoin chain',
        relatedBottomListH4_1: 'Additional issuance',
        relatedBottomListH4_2: 'Destroy',
        relatedBottomListHash: 'Transaction Hash:',
    },
    toolBlockChainBrowser: {
        title: 'Blockchain Browser',
    },
    firmOffer: {

        titleLabel0: 'Contract Address:',
        titleLabel1: 'Holding Addresses',
        titleLabel2: 'Unique Trading Addresses',
        titleLabel3: 'Transactions',
        titleLabel4: 'Transaction Volume',
        titleLabel5: 'Liquidity',
        titleLabel6: 'Total Market Cap',
        titleLabel7: 'Creation Time',
        titleLabel8: 'Total Locked Market Cap',
        tabs1: 'Transaction History',
        tabs2: 'Pool Changes',
        tabs3: 'Holding Addresses',
        tabs4: 'Funds',
        transactionTh1: 'Time',
        transactionTh2: 'Price($)',
        transactionTh3: 'Trade($)',
        transactionTh4: 'Amount',
        transactionTh5: 'Wallet',
        transactionAddTrace: 'Confirm tracking this wallet address?',
        transactionAddTraceSuccess: 'Successfully added!',
        tag1: 'Buy',
        tag2: 'Sell',
        tag3: 'Increase',
        tag4: 'Decrease',
        poolTip: 'The first pool data is displayed by default',
        poolTh1: 'Time',
        poolTh2: 'Type',
        poolTh3: 'Trade($)',
        poolTh4: 'Amount',
        poolTh5: 'Wallet',
        poolCurrent: 'Total Addresses',
        Explain1: 'Total Addresses:',
        Explain2: 'Top 10 Proportion:',
        Explain3: 'Snipers:',
        Explain4: 'Suspicious Holding Addresses:',
        positionTh1: 'Rank',
        positionTh2: 'Wallet',
        positionTh3: 'Holding',
        positionTh4: 'Amount',
        positionTh5: '24H Chg.',
        positionTh6: 'Block Information',
        financeType1: 'Top Buyers',
        financeType2: 'Top Sellers',
        financeTh1buy: 'Net Buying',
        financeTh1sell: 'Net Selling',
        financeTh2buy: 'Buying Amount($)',
        financeTh2sell: 'Selling Amount($)',
        financeTh3: 'User',
        addTrace: 'Confirm tracking this address?',
        addTraceSuccess: 'Successfully added!',

"title": "Token details"
},
    smartMoneySmall: {
        cycle1: '1 point',
        cycle2: '5 points',
        cycle3: '30 points',
        cycle4: '1 o\'clock',
        cycle5: '4 o\'clock',
        cycle6: '1 day',
        klineIndicator1: 'Buy',
        klineIndicator2: 'Sell',
        tableTh1: 'Purchase quantity',
        tableTh2: 'purchasing price',
        tableTh3: 'Quantity sold',
        tableTh4: 'Sale amount',
        tableTh5: 'Floating',
        tableThAddress: 'address:',
        detailsReturn: 'Back to list',
        detailsAddress: 'address:',
        detailsTokenAddress: 'Token address:',
        detailsChainName: 'Chain name:',
        detailsTrackerType: 'Trading direction:',
        detailsTrackerTypeVal1: 'Buy',
        detailsTrackerTypeVal2: 'Sell',
        detailsAmount: 'Purchase quantity:',
        detailsAmountUsd: 'Purchase amount USD:',
        detailsTransactionTime: 'transaction hour:',
        detailsHash: 'Transaction hash:',
    },
    hitNewRobot: {
        title: 'New Stock Robot',
        topImg1: 'Leading the Future of Technology',
        topImg2: 'New Stock Robot',
        topImg3: 'September 30',
        topImg4: 'Officially launched',
        topImg5: 'View rules>>',
        type1: 'New Stock List',
        hitNewlistTh1: 'Token Information',
        hitNewlistTh2: 'Token Price',
        hitNewlistTh3: 'Pool Percentage',
        hitNewlistTh4: 'Initial/Remaining',
        hitNewlistTh5: 'Initial Time',
        createBtn: 'Create',
        createTitle: 'Create Robot',
        createLabel1: 'Exchange Name:',
        createLabel2: 'Coin Pair Name:',
        createLabel3: 'Listing Time:',
        createLabel7: 'Available balance：',
        createLabel4: 'Estimated Purchase Quantity:',
        createLabel5: 'Estimated Purchase Price:',
        createLabel6: 'Buying time：',
        createLabel4Err: 'Please enter the estimated purchase quantity',
        createLabel5Err: 'Please enter the estimated purchase price',
        createLabel6Err: 'Please choose a time to purchase',
        createLabel6Select1: 'Select Year Month Day',
        createLabel6Select2: 'Select hours minutes seconds',
        createTip: 'The purchase value must be>=10 USDT',
        createSuccess: 'Created successfully! ',
        type2: 'Robot list',
        robotListStatus1: 'To executed',
        robotListStatus2: 'Ended',
        robotListBinanceStatus1: 'Success',
        robotListBinanceStatus2: 'Failed',
        robotList1: 'Execution time:',
        robotList2: 'Cancel robot',
        robotList3: 'Coin pair',
        robotList4: 'Price',
        robotList5: 'Quantity',
        robotCancel: 'Cancel successfully',
    },
    hitNewRobotInfo: {
        title: 'Trade',
        title2: 'Trade History'
    },
    hitNewRobotRule: {
        title: 'Introduction to the digital coin new robot',
        h2_1: 'Core advantages:',
        label1_1: 'Efficient algorithm:',
        label1_2: 'Deep integration:',
        label1_3: 'Big data processing:',
        label1_4: 'Intelligent strategy:',
        label1_5: 'Security guarantee:',
        label1_6: 'Automated trading:',
        label1_7: 'Optimized experience:',
        p1_1: 'Built-in efficient algorithms, millisecond-level trading decisions, and accurate capture of market dynamics. ',
        p1_2: 'Integrate mainstream exchange APIs such as Binance, HTX, and OKX to ensure comprehensive and accurate data. ',
        p1_3: 'Use Apache Kafka and Flink technology to collect and process market data in real time. ',
        p1_4: 'Combined with TensorFlow or PyTorch framework, use historical data and trends to optimize new strategies. ',
        p1_5: 'Distributed architecture and multiple encryption technologies to ensure user data and transaction security. ',
        p1_6: 'Explore smart contracts and cross-chain technologies in the future to achieve DEX automated trading and efficient asset management. ',
        p1_7: 'Continuously optimize the interface and interactive design, provide intuitive data visualization tools, and enhance user experience. ',
        h2_2: 'Member upgrade standards:',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: 'Directly promote 3 people, the team reaches 100 people.',
        p2_2: 'Directly promote 5 people, the team reaches 200 people.',
        p2_3: 'Directly promote 5 people, two of whom reach v2.',
        p2_4: 'Directly promote 5 people, two of whom reach v3.',
        p2_5: 'Directly promote 5 people, two of whom reach v4.',
        p2_6: 'Directly promote 5 people, two of whom reach v5.',
        p2_7: 'Directly promote 5 people, two of whom reach v6.',
        h2_3: 'Robot distribution standard:',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: 'Get 1 robot.',
        p3_2: 'Get 3 robots.',
        p3_3: 'Get 5 robots.',
        p3_4: 'Get 6 robots.',
        p3_5: 'Get 7 robots.',
        p3_6: 'Get 9 robots.',
        p3_7: 'Get 10 robots and get 5 more robots, a total of 15 robots.',
        h2_4: 'Robot effective operation conditions:',
        label4_1: 'Continuous sign-in:',
        label4_2: 'Activation conditions:',
        label4_3: 'Sign-in interruption:',
        p4_1: 'Members need to keep signing in every day to ensure the effective operation of the robot.',
        p4_2: 'Only members who sign in continuously can activate the new stock service. ',
        p4_3: 'If you miss the sign-in on the same day, the new stock robot will stop running the next day, and will automatically activate at midnight the next day after signing in again. ',
        h2_5: 'Summary:',
        p5: 'The digital currency new stock robot module of this platform provides members with automated, efficient and safe new stock services through efficient algorithms and intelligent strategies. With the continuous advancement of technology, we will continue to optimize the user experience, expand more diversified new stock options, and help members realize asset appreciation'
    },
    invite: {
        title: 'Invite friends',
        info1: 'Invite friends to join the registration/team',
        info2: 'Opportunity to get the opportunity to open the robot/promotion income',
        info3: 'Hi! Welcome to the TokenTrend platform',
        info4: 'Specially customized for newcomers in the coin circle, a new tool to get started with one click',
        btn: 'Copy the invitation link'
    }
,
    hyperliquid: {
        searchPlaceholder: 'Enter wallet address to query positions...',
        searchBtn: 'Search',
        title: 'Whale Position Monitor',
        dataCount: '{0} whale positions',
        long: 'Long',
        short: 'Short',
        cross: 'Cross',
        isolated: 'Isolated',
        positionValue: 'Position Value',
        positionSize: 'Position Size',
        entryPrice: 'Entry Price',
        markPrice: 'Mark Price',
        unrealizedPnl: 'Unrealized PnL',
        noData: 'No data',
        enterAddress: 'Please enter a wallet address',
        enterValidAddress: 'Please enter a valid wallet address',
        copyAddress: 'Copy address',
        whale: 'Whale',
        explorer: 'Explorer',
        accountTotalValue: 'Account Total Value',
        perpetual: 'Perpetual',
        freeMarginAvailable: 'Free Margin Available',
        withdrawable: 'Withdrawable',
        totalPositionValue: 'Total Position Value',
        leverageRatio: 'Leverage Ratio',
        marginUsed: 'Margin Used',
        usedRatio: 'Used Ratio',
        perpTotalValue: 'Perp Total Value',
        positionsCount: '{0} Positions',
        avgMarginUsedRatio: 'Average Margin Used Ratio',
        directionBias: 'Direction Bias',
        longExposure: 'Long Exposure',
        shortExposure: 'Short Exposure',
        positionDistribution: 'Position Distribution',
        longValue: 'Long Value',
        shortValue: 'Short Value',
        roe: 'ROE',
        upnl: 'uPnL',
        perpPositions: 'Perp Positions ({0})',
        symbol: 'Symbol',
        entryAvgPrice: 'Entry Avg. Price',
        margin: 'Margin',
        fundingCost: 'Funding Cost',
        noPositions: 'No positions found',
        userAddressRequired: 'User address is required',
        addressCopied: 'Address copied',
        copyFailed: 'Copy failed',
        bullish: 'Bullish',
        bearish: 'Bearish',
        neutral: 'Neutral'
    },
"burstHeatmapDetails": {"title":"Liquidation heatmap"},
"burstCoinStatisticsDetails": {"title":"Coin liquidation statistics"},
"forumPublish": {"title":"Create post"},
"forumDetails": {"title":"Community post"},
"consultDetails": {"title":"Article details"}
}
